import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getSitemapUrls = () =>
  axiosInstance.get(`${LANDING_API_URL}/sitemaps`, {
    headers: authHeaders(),
  });

export const getParentSitemaps = () =>
  axiosInstance.get(`${LANDING_API_URL}/site-map-get-parents`, {
    headers: authHeaders(),
  });

export const createSitemapUrlRequest = (sitemapData) =>
  axiosInstance.post(`${LANDING_API_URL}/sitemaps`, sitemapData, {
    headers: authHeaders(),
  });

export const updateSitemapUrlRequest = (id, sitemapData) =>
  axiosInstance.post(`${LANDING_API_URL}/sitemaps/${id}`, sitemapData, {
    headers: authHeaders(),
  });

export const removeSitemapUrl = (sitemapId) =>
  axiosInstance.delete(`${LANDING_API_URL}/sitemaps/${sitemapId}`, {
    headers: authHeaders(),
  });
